import React from "react";
import TimeLineImage from "../../../assets/Images/TimelineImage.png";
import Logo1 from "../../../assets/TimeLineLogo/Logo1.svg";
import Logo2 from "../../../assets/TimeLineLogo/Logo2.svg";
import Logo3 from "../../../assets/TimeLineLogo/Logo3.svg";
import Logo4 from "../../../assets/TimeLineLogo/Logo4.svg";
import logo from "../../../assets/Logo/COSMINNOX.png";

const TimeLine = [
  {
    Logo: Logo1,
    Heading: "Startup Acceleration",
    Description: "Expert mentorship and structured growth programs.",
  },
  {
    Logo: Logo2,
    Heading: "Industry-Academia Collaboration",
    Description: "Industry-Academia Collaboration",
  },
  {
    Logo: Logo3,
    Heading: "Deep-Tech Focus",
    Description: "Supporting AI, robotics, semiconductor, and high-impact tech ventures.",
  },
  {
    Logo: Logo4,
    Heading: "Supporting AI, robotics, semiconductor, and high-impact tech ventures.",
    Description: "Connecting with Startup India, NITI Aayog, and global investors",
  },
];

const TimelineSection = () => {
  return (
    <div>
      <div className="flex flex-col lg:flex-row gap-20 mb-20 items-center">
        <div className="lg:w-[45%] flex flex-col gap-14 lg:gap-3">
          {TimeLine.map((ele, i) => {
            return (
              <div className="flex flex-col lg:gap-3" key={i}>
                <div className="flex gap-6" key={i}>
                  <div className="w-[52px] h-[52px] bg-white rounded-full flex justify-center items-center shadow-[#00000012] shadow-[0_0_62px_0]">
                    <img src={ele.Logo} alt="" />
                  </div>
                  <div>
                    <h2 className="font-semibold text-[18px] dark:text-white ">
                      {ele.Heading}
                    </h2>
                    <p className="text-base dark:text-richblack-50">
                      {ele.Description}
                    </p>
                  </div>
                </div>
                <div
                  className={`hidden ${
                    TimeLine.length - 1 === i ? "hidden" : "lg:block"
                  }  h-14 border-dotted border-r border-richblack-100 bg-richblack-400/0 w-[26px]`}
                ></div>
              </div>
            );
          })}
        </div>
        <div className="relative w-full max-w-[500px] mx-auto shadow-[0px_-2px_20px_6px_#cbd5e0]">
          <div className="absolute lg:left-[50%] lg:bottom-0 lg:translate-x-[-50%] lg:translate-y-[50%] bg-[#CD1412] flex lg:flex-row flex-col text-white uppercase py-5 gap-4 lg:gap-0 lg:py-10 ">
            {/* Section 1 */}
            {/* <div className="flex gap-5 items-center lg:border-r border-[#ffb4b3] px-7 lg:px-14">
              <h1 className="text-3xl font-bold w-[75px]">30+</h1>
              <h1 className="text-[#ffb4b3] text-sm w-[75px]">
                Experienced Experts
              </h1>
            </div> */}

            {/* Section 2 */}
            {/* <div className="flex gap-5 items-center lg:px-14 px-7">
              <h1 className="text-3xl font-bold w-[75px]">54+</h1>
              <h1 className="text-[#ffb4b3] text-sm w-[75px]">
                types of courses
              </h1>
            </div> */}
            <div></div>
          </div>
          <img
            src={logo}
            alt="timelineImage"
            className="shadow-[#f78886] shadow-[20px_20px_0px_0px] object-contain  lg:h-[500px] w-full h-auto overflow-hidden"
          />
        </div>
      </div>
    </div>
  );
};

export default TimelineSection;
